import $ from 'jquery';

class NotificationAPI {
  constructor(urls) {
    this.urls = urls;
  }

  get(id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method:      "GET",
        contentType: "application/json; charset=UTF-8",
        headers:     { Accept: "application/json" },
        url:         this.urls.notificationURL.replace(':id', id),
        success:     resolve,
        error:       (response) => { reject(new Error(response)); }
      });
    });
  }

  update(id, attrs) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method:      "PATCH",
        contentType: "application/json; charset=UTF-8",
        headers:     { Accept: "application/json" },
        url:         this.urls.notificationURL.replace(':id', id),
        data:        JSON.stringify({ notification: attrs }),
        success:     resolve,
        error:       (response) => { reject(new Error(response)); }
      });
    });
  }

  markAllAsRead() {
    return new Promise((resolve, reject) => {
      $.ajax({
        method:  "POST",
        headers: { Accept: "application/json" },
        url:     this.urls.markAllAsRead,
        success: resolve,
        error:   (response) => { reject(new Error(response)); }
      });
    });
  }

  fetch() {
    return new Promise((resolve, reject) => {
      $.ajax({
        method:  "GET",
        headers: { Accept: "application/json" },
        url:     this.urls.getNotifications,
        success: resolve,
        error:   (response) => { reject(new Error(response)); }
      });
    });
  }
}

export default NotificationAPI;
